const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const addAffiliateApi = async (affiliateData) => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.error('[addAffiliateApi] Ошибка: Токен авторизации не найден.');
    // throw new Error('Токен авторизации не найден.');
  }



  try {
    const response = await fetch(`${API_BASE_URL}/admin/user/affiliator-accounts`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(affiliateData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[addAffiliateApi] Ошибка при добавлении аффилиата:', errorData);
      throw { ...errorData, statusCode: response.status };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[addAffiliateApi] Ошибка сети или другая ошибка при добавлении аффилиата:', error);
    throw error;
  }
};